import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import renderHTML from "react-render-html";
import { getTestimonial } from "../../store/actions/testimonials_action";
import Spinner from "../../components/layout/Spinner";
import SingleItem from "../../components/template/SingleItem";
import { Link } from "react-router-dom";
const ViewTestimonial = ({
  getTestimonial,
  match,
  testimonial: { loading, testimonial },
}) => {
  useEffect(() => {
    getTestimonial(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Testimonials"
          mainLinkTitle="Testimonials"
          mainLinkUrl="/testimonials"
          activeLink="View"
        />
        {!loading ? (
          testimonial && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <div>
                        <h4 className="card-title">
                          {testimonial.name} <span>View</span>
                        </h4>
                        <p className="card-title-desc">
                          <Link
                            to="/testimonials"
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-angle-left"></i> Testimonials
                          </Link>
                          <Link
                            to={`/testimonials/${testimonial.id}/edit`}
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="card-body">
                      <SingleItem title="title" value={testimonial.title} />

                      {testimonial.featured_image && (
                        <SingleItem title="Featured Image">
                          <img
                            src={`${testimonial.featured_image}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                            }}
                          />
                        </SingleItem>
                      )}
                      {testimonial.gallery && (
                        <SingleItem title="Gallery">
                          {testimonial.gallery.map((pic) => {
                            return (
                              <img
                                src={pic}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            );
                          })}
                        </SingleItem>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-header"> Content </div>
                    <div className="card-body">
                      <div className="card-content">
                        {testimonial.content && renderHTML(testimonial.content)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ testimonial: state.testimonial });

const mapDispatchToProps = { getTestimonial };

export default connect(mapStateToProps, mapDispatchToProps)(ViewTestimonial);
